import React from 'react';
import Message from '../common/message';
import { withLocalize, Translate } from "react-localize-redux";

class NotAuthorizedComponent extends React.Component {
    render() {
        return (
            <div style={{marginTop: "3.5rem", display: "flex", justifyContent:"center"}}>
                <Message type='warning' style={{ marginTop: '1em' }} message={<Translate id='UnhappyUser.NotAuthorized' />} />
            </div>
        );
    }
}
export default withLocalize(NotAuthorizedComponent);
